const Form082SC = {
    stepName: {
        importantNotes: "重要提示",
        basicInformation: "基本资料",
        declaration: "声明",
        confirmation: "确认",
    },
    tooltipList: {
        toopltip1:
            "1. 放取侍产假的日數最多为5个工作天，有关批核侍产假的详情请参阅教育局通告第16/2015号。",
        toopltip2: "请删去不适用者",
    },
    importantNotesContent: {
        // note: "教育局会利用本表格所载的个人资料，作以下其中一种或多种用途︰",
        // a: "办理与聘用有关的事宜；",
        // b: "处理发放薪金津贴及其他政府资助；",
        // c: "计算公积金的供款；",
        // d: "进行核数工作；",
        // e: "进行研究及统计资料，以便规划教育服务；",
        // f: "处理有关教育专业人员发展的事宜；",
        // g: "执行相关《资助则例》、《教育条例》、《教育规例》及《补助/津贴学校公积金规则》的规定。",
        // note1: "申请人必须在本表格上填写个人资料。申请人如不提供这些资料，申请的处理工作及结果或会受影响。",
        // note2: "本表格所搜集的个人资料，或会向其他获授权的政府决策局/部门/机构披露作上述用途。",
        // note3: "根据《个人资料(私隐)条例》，第18和22条及附表1保障资料第6原则的规定，你有权要求查阅及改正你的个人资料。要求查阅的权利，包括要求提供本表格所载个人资料的副本，但须缴付费用。",
        // note4: "如欲查询有关本表格所搜集的个人资料，包括要求查阅及改正资料事宜，需以书面方式向有关高级学校发展主任提出。",
        title: "个人资料收集声明",
        p_title: "收集个人资料的目的",
        p1_1: "你在本表格提供的个人资料，会供教育局用于以下一项或多项用途：",
        p1_a: "处理、核实及查证就发还侍产假薪酬(只适用于已离职的教职员) 的申请；",
        p1_b: "就上文(a)项所述申请的处理、核实及查证，将个人资料与政府相关政策局／部门资料库进行核对；",
        p1_c: "将个人资料与教育局资料库进行核对，以核实／更新教育局的记录；",
        p1_d: "培训及发展，包括发出计划／活动邀请、处理发还课程费用申请、 评审提名、奖项和奖学金，以及监察达标进度；",
        p1_e: "处理及审核拨款／补助／津贴申请、发放拨款／补助／津贴，以及审计； ",
        p1_f: "编制统计资料、研究及政府刊物；以及",
        p1_g: "执行规则及规例[包括《教育条例》(香港法例第279章)及其附属法例(例如《教育规例》、《补助学校公积金规则》、《津贴学校公积金规则》)和《资助则例》]。",

        p2: "你必须按本表格的要求及于本局处理本表格的过程中提供个人资料。假如你没有提供该等个人资料，本局可能无法办理或继续处理有关申请。",

        p_title3: "可获转移资料者",
        p3_1: "你提供的个人资料会供教育局人员取阅。除此之外，本局亦可能会向下列各方或在下述情况转移或披露该等个人资料：",
        p3_a: "政府其他政策局及部门，以用于上文第1段所述的用途； ",
        p3_b: "与本表格相关的学校，以用于上文第1段所述的用途；",
        p3_c: "你曾就披露个人资料给予订明同意；以及",
        p3_d: "根据适用于香港的法例或法庭命令授权或规定披露个人资料。",

        p_title4: "查阅个人资料",
        p4: "你有权要求查阅及更正教育局所持有关于你的个人资料。如需查阅或更正个人资料，请以书面向有关高级学校发展主任提出，并寄交教育局网页(https://www.edb.gov.hk/sc/contact-us/reo.html)所载区域教育服务处地址或电邮至 <a href='mailto: edbinfo@edb.gov.hk'>edbinfo@edb.gov.hk</a>。",

        termsConditions: "我已阅读、理解并同意上述条款和条件。",
        iamStatement: "本人理解学校审批人需要拥有「智方便+」帐户才能处理申请。",
    },
    schoolInformation: {
        title: "学校资料 ",
        label: {
            nameOfSchool: "学校名称",
            schoolCode: "学校代码",
            month: "月份",
            year: "年份",
        },
    },
    basicInformationContent: {
        title: "甲部 基本资料",
        paternityLeaveTitle: "教职员资料",
        applicantTitle: "放取侍产假的日期",
        salaryTitle: "薪酬",
        label: {
            name: "姓名",
            staffRefNo: "员工档号",
            post: "职位",
            cesssationOfEmploymentDate: "离职日期",
            paternityLeaveFrom: "由",
            paternityLeaveTo: "至",
            noOfworkingDays: "日数(a)",
            monthlySalary: "月薪（元）(b)",
            dailySalary: "日薪（元）(c) = (b) ÷ 该月日数",
            totalAmountPerRow: "发还薪金总额（元）(d) = (c) x (a)",
            total: "总额（元）",
            leaveType: "无薪假期/年假",
            leaveOption: {
                noPay: "无薪假期",
                annual: "年假",
            },
            emolumentsAttachment: "薪酬收据",
            otherAttachment:
                "其他附件（例如学校来信、辞职信、出生证明、分娩日期、侍产假日期等）",
        },
    },
    declarationContent: {
        title: "乙部 声明",
        label: {
            applicantType: "校监/校长",
            applicantTypeOption: {
                supervisor: "校监",
                schoolHead: "校长",
            },
            applicantName: "姓名",
            claimDate: "申请日期",
            contactPersonName: "联络人",
            telNo: "电话号码",
            ssdo: "高级学校发展主任",
            beforeSSDOText: "副本送︰高级学校发展主任（",
            afterSSDOText: "）",
        },
        subTitle: "本人证实 –",
        textBeforeTooltip2:
            "本校已按照相关的通告处理有关教职员的侍产假事宜。该教职员在上述期间放取的侍产假因未能递交相关证明文件，已以",
        textAfterTooltip2: "替代，其后他已补交相关的证明文件，并得到学校核实；",
        p2: "有关侍产假的薪酬已支付予相关的教职员。随函附上有关收据，以供记录存档。",
    },
    errorMsg: {
        label: {
            noOfworkingDays: "日数",
            monthlySalary: "月薪",
            dailySalary: "日薪",
        },
    },
};
export default Form082SC;
